import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { SingleCard } from './layouts';
import { LoginForm, ResetPasswordForm, ChangePasswordForm, Subscribe} from './components';
import Logo from '../src/assets/RedLoreLogin.png';
export default function UnauthenticatedContent() {
  return (
    <Switch>
      <Route exact path='/login' >
        <div className='logo_img'>
          <img src={Logo} alt='Redlore'/>
        </div>
        <SingleCard title="Sign In">
          <LoginForm />
        </SingleCard>
      </Route>
      <Route exact path='/reset-password' >
        <SingleCard
          title="Reset Password"
          description="Please enter the email address that you used to register, and we will send you a link to reset your password via Email."
        >
          <ResetPasswordForm />
        </SingleCard>
      </Route>
      <Route exact path='/subscribe' >
      <div className='logo_img'>
          <img src={Logo} alt='Redlore'/>
        </div>
        <SingleCard
          title="Redboard Subscription"
          className="subscribe-card"
        >
          <Subscribe />
        </SingleCard>
      </Route>
      <Route exact path='/change-password/:recoveryCode' >
        <SingleCard title="Change Password">
          <ChangePasswordForm />
        </SingleCard>
      </Route>
      <Redirect to={'/login'} />
    </Switch>
  );
}
